$('.test-container').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.437 1.1478L2.98663 20.5981L22.437 40.0485" stroke="#282828" stroke-width="3"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.56308 40.0485L21.0134 20.5981L1.56308 1.1478" stroke="#282828" stroke-width="3"/></svg></button>',
        dots: true,
        speed: 300,
        infinite: true,
        centerMode: true,
        centerPadding: "0px",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false
        }
      }
    ]
});

$(document).ready(function() {
    $('.product-form__input input[type=radio]:checked').closest('label').addClass('active');
    // When a radio button is clicked
    $('.product-form__input input[type=radio]').on('click', function() {
        // Remove 'active' class from all parent divs
        $('.product-form__input input[type=radio]').closest('label').removeClass('active');
        
        // Add 'active' class to the parent div of the clicked radio button
        $(this).closest('label').addClass('active');
    });
});

// how its work slider
 $('.image_slider_1').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.437 1.1478L2.98663 20.5981L22.437 40.0485" stroke="#282828" stroke-width="3"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.56308 40.0485L21.0134 20.5981L1.56308 1.1478" stroke="#282828" stroke-width="3"/></svg></button>',
        dots: false,
        speed: 300,
        infinite: false,
        centerMode: true,
        centerPadding: "0px",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false
        }
      }
    ]
});
         
// How its work-     
$('.how_its_slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.437 1.1478L2.98663 20.5981L22.437 40.0485" stroke="#282828" stroke-width="3"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.56308 40.0485L21.0134 20.5981L1.56308 1.1478" stroke="#282828" stroke-width="3"/></svg></button>',
        dots: false,
        speed: 300,
        infinite: true,
        centerMode: true,
        centerPadding: "0px",
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
      
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:false,
          dots: true
        }
      },
          
     {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots: true
      }
    }
    ]
});
// read more 
